import { render, staticRenderFns } from "./courseCategory.html?vue&type=template&id=e84080a8&"
import script from "./courseCategory.js?vue&type=script&lang=js&"
export * from "./courseCategory.js?vue&type=script&lang=js&"
import style0 from "./courseCategory.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports